import { Component, effect, inject } from '@angular/core';
import { LocaleService } from 'src/app/services/locale';
@Component({
  selector: 'app-carbon',
  imports: [],
  template: `
    <div class=" ">
      <h1 class="text-base sm:text-lg lg:text-xl futura text-[#043B22]">{{ locale.carbon.heading }}</h1>
      <div class="text-xs sm:text-sm text-[#616161] mt-2.5 sm:mt-3 w-full max-w-4xl 2xl:max-w-6xl leading-relaxed">
        <p class="mb-3">{{ locale.carbon.subheading }}</p>
        <ul class="list-disc ml-3 sm:ml-5 space-y-2.5 sm:space-y-3">
          <li>
            <span class="font-bold futura text-[#043B22]">
              {{ locale.carbon.subpoint1 }}:
            </span>
            <span class="ml-1">{{ locale.carbon.subpoint1_data }}</span>
          </li>
          <li>
            <span class="font-bold futura text-[#043B22]">
              {{ locale.carbon.subpoint2 }}:
            </span>
            <span class="ml-1">{{ locale.carbon.subpoint2_data }}</span>
          </li>
          <li>
            <span class="font-bold futura text-[#043B22]">
              {{ locale.carbon.subpoint3 }}:
            </span>
            <span class="ml-1">{{ locale.carbon.subpoint3_data }}</span>
          </li>
        </ul>
      </div>
    </div>
  `
})
export class CarbonComponent {
  localeService = inject(LocaleService);
  locale = this.localeService.locale();

  constructor() {
    effect(() => {
      this.locale = this.localeService.locale();
    });
  }
}
